<template>
  <div class="search-result-page">
    <div class="header">
      <img src="../../assets/image/Upload/logo2.png"/>
      <input placeholder="请输入金融编号后四位" v-model="erpidC" @keyup="enterSearch"></input>
      <button @click="search" :disabled="searchDisabled">搜索</button>
      <div @click="clearVal" v-if="erpidC.length!=0"><img src="../../assets/image/Upload/error_sign.png"/></div>
    </div>
    <div class="list-part">
      <div class="nothing" v-if="nothingFlag">
        <img src="../../assets/image/Upload/nothing.png"/>
        <p>该编号不存在，请重新输入</p>
      </div>
      <div class="list-item" v-for="item in orderList" v-if="!nothingFlag" @click="toUploadImagePage(item.erpidC)">
        <div class="top">
          <div>
            <p>编号：</p>
            <p>{{item.erpidC}}</p>
          </div>
          <img src="../../assets/image/Upload/arrow_right.png"/>
        </div>
        <div class="bottom">
          <div>
            <p>客户：</p>
            <p>{{item.erpnameC}}</p>
          </div>
          <div>
            <p>金融状态：</p>
            <p>{{item.crmFinapplystatusC}}</p>
          </div>
          <div>
            <p>手机号码：</p>
            <p>{{item.erpmobileC}}</p>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { Indicator } from 'mint-ui';
  import common from '../../utils/common'
  import VueCookies from 'vue-cookies'
  import _ from 'lodash'
  Vue.use(VueCookies)
  export default {
    name: "searchResult",
    data() {
      return {
        lastErpidC: '',
        erpidC: '',
        orderList: [],
        nothingFlag: false,
        searchDisabled: false
      }
    },
    mounted(){
      if(!VueCookies.get('tokenflag') || !sessionStorage.getItem("access_token")){
        common.redirect(this, 'upload_login')
        return
      }
      if(!common.isEmpty(sessionStorage.getItem("lasterpidc"))) {
        this.erpidC = sessionStorage.getItem("lasterpidc")
        this.orderList = JSON.parse(sessionStorage.getItem("lastresult"))
      }
    },
    watch:{
      erpidC(val, oldVal){//普通的watch监听
        if(common.isEmpty(val)){
          this.nothingFlag = false
          this.orderList = []
        }
      }
    },
    methods: {
      enterSearch:_.throttle(function(event) {
        if(event.keyCode == 13) {
          this.search()
        }
        return
      }, 1000),

      search() {
        const that = this
        if(this.erpidC.length < 4) {
          common.tipToast('请至少输入编码后4位')
          return
        }
        that.searchDisabled = true
        that.orderList = []
        Indicator.open({
          text: '加载中...',
          spinnerType: 'snake'
        });
        that.$axios({
          method: 'post',
          url: '/crm/tesla/search',
          data:  {erpidC: that.erpidC},
          headers: {
            'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
          },
        }).then(function (res) {
          that.nothingFlag = false
          that.orderList = res.data.data
        }).catch(err=>{
          if(err.data.code == '1' && common.isEmpty(err.data.data)) {
            that.nothingFlag = true
            return
          }
          that.nothingFlag = false
        }).finally(()=>{
          Indicator.close();
          that.searchDisabled = false
        })
      },

      clearVal() {
        this.erpidC = ''
      },

      toUploadImagePage(id) {
        common.redirect(this, 'upload')
        sessionStorage.setItem("erpidc", id)
        sessionStorage.setItem("lasterpidc", this.erpidC)
        sessionStorage.setItem("lastresult",JSON.stringify(this.orderList))
      }
    }
  }
</script>

<style scoped>
  .search-result-page {
    /*border: 1px solid black;*/
    margin: 0 auto;
    width: 7.5rem;
    min-height: 100vh;
    background-color: #fafafa;
  }

  .search-result-page > .header {
    padding: 0.28rem 0;
    position: fixed;
    top: 0;
    width: 7.5rem;
    background-color: #fff;
    font-size: 0;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    box-shadow: 0 0 0.14rem 0 rgba(0,0,0,0.10);
    z-index: 1;
  }
  .search-result-page > .header > img {
    margin: 0 0.3rem;
    width: 0.4rem;
    height: 0.6rem;
  }
  .search-result-page > .header > input {
    padding-left: 0.16rem;
    width: 4.38rem;
    height: 0.78rem;
    outline: none;
    background: #FAFDFF;
    border: 1px solid #54B4FF;
    font-size: 0.26rem;
  }
  .search-result-page > .header > div {
    position: absolute;
    margin: auto 0;
    top: 0;
    bottom: 0;
    right: 2.14rem;
    width: 0.5rem;
    height: 0.78rem;
    display: flex;
    align-items: center;
  }
  .search-result-page > .header > div > img {
    width: 0.24rem;
    height: 0.24rem;
  }

  .search-result-page > .header >  button {
    margin-left: 0.21rem;
    width: 1.62rem;
    height: 0.78rem;
    border-width: 0;
    outline: none;
    font-size: 0.26rem;
    color: #FFFFFF;
    background: #54B4FF;
  }
  .search-result-page  {
    padding-top: 1.42rem;
  }
  .search-result-page > .list-part > .list-item {
    background-color: #fff;
    margin: 0.25rem auto 0 auto;
    width: 7.1rem;
  }

  .search-result-page > .list-part > .nothing {
    margin-top: 2.72rem;
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    font-size: 0;
  }
  .search-result-page > .list-part > .nothing > img{
    width: 1.99rem;
    height: 1.99rem;
  }
  .search-result-page > .list-part > .nothing > p {
    margin-top: 0.53rem;
    font-size: 0.3rem;
    color: #6B6C6C;
    letter-spacing: 0;
    line-height: 0.42rem;
  }
  .search-result-page > .list-part {
    padding-bottom: 0.3rem;
  }
  .search-result-page > .list-part > .list-item {
    position: relative;
  }
  .search-result-page > .list-part > .list-item >.top {
    border-bottom: 0.01rem solid #E8E8E8;
    padding: 0.24rem 0 0.195rem 0;
    margin: 0 auto;
    width: 6.5rem;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: space-between;
  }
  .search-result-page > .list-part > .list-item >.top > div {
    display: flex;
    align-items: center;
  }
  .search-result-page > .list-part > .list-item >.top > div > p {
    height: 0.42rem;
    font-size: 0.26rem;
    line-height: 0.42rem;
    color: #A2A2A2;
    letter-spacing: 0;
    line-height: 0.42rem;
  }
  .search-result-page > .list-part > .list-item >.top > div > p:last-child {
    color: #444444;
  }
  .search-result-page > .list-part > .list-item > .bottom {
    /*margin: 0.08rem 0 0 0.22rem;*/
    margin: 0.15rem auto 0 auto;
    width: 6.5rem;
    display: flex;
    flex-flow: row wrap;
    align-items: center;
    justify-content: space-between;
  }
  .search-result-page > .list-part > .list-item > .bottom > div {
    padding-bottom: 0.23rem;
    width: 50%;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
  }

  .search-result-page > .list-part > .list-item > .bottom > div:nth-child(2n) {
    justify-content: flex-end;
  }
  .search-result-page > .list-part > .list-item > .bottom > div > p {
    margin-top: 0.08rem;
    font-size: 0.26rem;
    color: #A2A2A2;
    letter-spacing: 0;
    line-height: 0.42rem;
  }
  .search-result-page > .list-part > .list-item > .bottom > div:first-child > p:last-child {
    max-width: 2rem;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
  .search-result-page > .list-part > .list-item > .bottom > div > p:last-child {
    color: #444444;
  }

  .search-result-page > .list-part > .list-item >.top > img {
    width: 0.16rem;
    height: 0.26rem;
  }

  .search-result-page > .list-part > .list-item > .turn {
    position: absolute;
    top: 0.642rem;
    bottom: 0;
    right: 0.243rem;
    width: 0.16rem;
    height: 0.26rem;
    font-size: 0;
  }

  .search-result-page > .list-part > .list-item > .turn > img {
    width: 100%;
    height: 100%;
  }

</style>



// WEBPACK FOOTER //
// src/components/Upload/searchResult.vue